import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useStore } from '@sagano/agent/stores';
import Header from '../Header';
import Sidebar from '../Sidebar';
import styles from './base.module.css';

const BaseLayout: React.FC = () => {
  const { stations, units, agentSelf } = useStore();

  useEffect(() => {
    stations.fetchStations();
  }, [stations]);

  useEffect(() => {
    units.fetchUnits();
  }, [units]);

  useEffect(() => {
    agentSelf.getAgentSelfInfo();
  }, [agentSelf]);

  return (
    <div className={styles.base}>
      <Header />
      <div className={styles.container}>
        <Sidebar />
        <main className={styles.main}>
          <div className={styles.inner}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default BaseLayout;
